import { request } from 'umi';
import type {
  FileTableListParams,
  CreateFileDataType,
  UpdateFileDataType,
} from '@/models/finance/file.d';

const { LME_FINANCE_FILE_URL } = API;

export async function queryFinanceFile(params: FileTableListParams | undefined) {
  return request(LME_FINANCE_FILE_URL, {
    method: 'GET',
    params,
  });
}

export async function queryFinanceParentFile(params: FileTableListParams | undefined) {
  return request(`${LME_FINANCE_FILE_URL}/parent`, {
    method: 'GET',
    params,
  });
}

export async function queryFinanceFileTypes(modelType: string) {
  return request(`${LME_FINANCE_FILE_URL}/types/${modelType}`, {
    method: 'GET',
  });
}

// export async function getFinanceFileLimit(params: { model_id: number; model_type: string }) {
//   return request(`${LME_FINANCE_FILE_URL}/limit`, {
//     method: 'GET',

//     params,
//   });
// }

export async function getFinanceFile(params: { id: string }) {
  const { id } = params;
  return request(`${LME_FINANCE_FILE_URL}/${id}`, {
    method: 'GET',
  });
}

export async function createFinanceFile(params: CreateFileDataType) {
  return request(LME_FINANCE_FILE_URL, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

export async function updateFinanceFile(params: UpdateFileDataType) {
  const { id } = params;
  return request(`${LME_FINANCE_FILE_URL}/${id}`, {
    method: 'PUT',
    data: {
      ...params,
    },
  });
}

export async function removeFinanceFile(params: { id: string }) {
  const { id } = params;
  return request(`${LME_FINANCE_FILE_URL}/${id}`, {
    method: 'DELETE',
  });
}

export async function downloadFinanceFile(params: { id: string }) {
  return request(`${LME_FINANCE_FILE_URL}/${params.id}/download`, {
    method: 'GET',
    responseType: 'blob',
  });
}

export async function previewFinanceFile(params: { id: string }) {
  const res = await request(`${LME_FINANCE_FILE_URL}/${params.id}/download`, {
    responseType: 'blob',
  });
  return res;
}
